export default [
    {
        todayorders:
        {
            options: {
                chart: {
                    sparkline: {
                        enabled: true,
                    },
                    dropShadow: {
                        enabled: true,
                        top: 1,
                        left: 1,
                        blur: 2,
                        color: "#000",
                        opacity: 0.7,
                    },
                },

                stroke: {
                    curve: "smooth",
                    width: 2,
                },
                markers: {
                    size: 0,
                },
                grid: {
                    padding: {
                        top: 0,
                        bottom: 0,
                        left: 0,
                    },
                },
                colors: ["#1e3d73"],
                tooltip: {
                    x: {
                        show: false,
                    }
                },
                responsive: [
                    {
                        breakpoint: 1351,
                        options: {
                            chart: {
                                height: 95,
                            },
                            grid: {
                                padding: {
                                    top: 35,
                                    bottom: 0,
                                    left: 0,
                                },
                            },
                        },
                    },
                    {
                        breakpoint: 1200,
                        options: {
                            chart: {
                                height: 80,
                            },
                            grid: {
                                padding: {
                                    top: 35,
                                    bottom: 0,
                                    left: 40,
                                },
                            },
                        },
                    },
                    {
                        breakpoint: 576,
                        options: {
                            chart: {
                                height: 95,
                            },
                            grid: {
                                padding: {
                                    top: 45,
                                    bottom: 0,
                                    left: 0,
                                },
                            },
                        },
                    },
                ],
            },
            series: [
                {
                    data: [41, 9, 36, 12, 44, 25, 59, 41, 66, 25],
                },
            ],
        },
        todayvisitors:
        {
            options:
            {

                chart: {
                    sparkline: {
                        enabled: true
                    },
                    dropShadow: {
                        enabled: true,
                        top: 1,
                        left: 1,
                        blur: 2,
                        color: '#28a745',
                        opacity: 0.7,
                    }
                },
                stroke: {
                    curve: 'smooth',
                    width: 2,
                },
                markers: {
                    size: 0
                },
                grid: {
                    padding: {
                        top: 0,
                        bottom: 0,
                        left: 0
                    }
                },
                colors: ['#28a745'],
                tooltip: {
                    x: {
                        show: false
                    }
                },
                responsive: [{
                    breakpoint: 1351,
                    options: {
                        chart: {
                            height: 95,
                        },
                        grid: {
                            padding: {
                                top: 35,
                                bottom: 0,
                                left: 0
                            }
                        },
                    },
                },
                {
                    breakpoint: 1200,
                    options: {
                        chart: {
                            height: 80,
                        },
                        grid: {
                            padding: {
                                top: 35,
                                bottom: 0,
                                left: 40
                            }
                        },
                    },
                },
                {
                    breakpoint: 576,
                    options: {
                        chart: {
                            height: 95,
                        },
                        grid: {
                            padding: {
                                top: 45,
                                bottom: 0,
                                left: 0
                            }
                        },
                    },
                }

                ]

            }
            ,
            series: [{
                data: [41, 9, 36, 12, 44, 25, 59, 41, 66, 25]
            }]
        },
        todaysale:
        {
            options:
            {

                chart: {
                    sparkline: {
                        enabled: true
                    },
                    dropShadow: {
                        enabled: true,
                        top: 1,
                        left: 1,
                        blur: 2,
                        color: '#17a2b8',
                        opacity: 0.7,
                    }
                },
                stroke: {
                    curve: 'smooth',
                    width: 2,
                },
                markers: {
                    size: 0
                },
                grid: {
                    padding: {
                        top: 0,
                        bottom: 0,
                        left: 0
                    }
                },
                colors: ['#17a2b8'],
                tooltip: {
                    x: {
                        show: false
                    }
                },
                responsive: [{
                    breakpoint: 1351,
                    options: {
                        chart: {
                            height: 95,
                        },
                        grid: {
                            padding: {
                                top: 35,
                                bottom: 0,
                                left: 0
                            }
                        },
                    },
                },
                {
                    breakpoint: 1200,
                    options: {
                        chart: {
                            height: 80,
                        },
                        grid: {
                            padding: {
                                top: 35,
                                bottom: 0,
                                left: 40
                            }
                        },
                    },
                },
                {
                    breakpoint: 576,
                    options: {
                        chart: {
                            height: 95,
                        },
                        grid: {
                            padding: {
                                top: 45,
                                bottom: 0,
                                left: 0
                            }
                        },
                    },
                }

                ]
            },
            series: [{
                data: [7, 9, 36, 12, 44, 25, 59, 41, 12, 25]
            }]
        },
        totalprofit:
        {
            options:
            {
                chart: {

                    sparkline: {
                        enabled: true
                    },
                    dropShadow: {
                        enabled: true,
                        top: 1,
                        left: 1,
                        blur: 2,
                        color: '#ffc107',
                        opacity: 0.7,
                    }
                },
                stroke: {
                    curve: 'smooth',
                    width: 2,
                },
                markers: {
                    size: 0
                },
                grid: {
                    padding: {
                        top: 0,
                        bottom: 0,
                        left: 0
                    }
                },
                colors: ['#ffc107'],
                tooltip: {
                    x: {
                        show: false
                    }
                },
                responsive: [{
                    breakpoint: 1351,
                    options: {
                        chart: {
                            height: 95,
                        },
                        grid: {
                            padding: {
                                top: 35,
                                bottom: 0,
                                left: 0
                            }
                        },
                    },
                },
                {
                    breakpoint: 1200,
                    options: {
                        chart: {
                            height: 80,
                        },
                        grid: {
                            padding: {
                                top: 35,
                                bottom: 0,
                                left: 40
                            }
                        },
                    },
                },
                {
                    breakpoint: 576,
                    options: {
                        chart: {
                            height: 95,
                        },
                        grid: {
                            padding: {
                                top: 45,
                                bottom: 0,
                                left: 0
                            }
                        },
                    },
                }

                ]
            },
            series: [{
                data: [21, 9, 36, 12, 44, 25, 59, 41, 66, 25]
            }]
        },
        mainbarchart:
        {
            options: {
                
                chart: {
                    height: 350,
                    type: 'bar',
                },
                responsive: [
                    {
                        breakpoint: 767,
                        options: {
                            chart: {
                                height: 220
                            }
                        }
                    }
                ],
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded'
                    },
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                colors: ['#1e3d73', '#17a2b8', '#1ee0ac'],            
                xaxis: {
                    categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct'],
                },
                yaxis: {
                    title: {
                        text: '(dollar)'
                    }
                },
                fill: {
                    opacity: 1
    
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + " thousands"
                        }
                    }
                }
            },
            series: [{
                name: 'Bitcoin',
                data: [76, 85, 101, 98, 87, 105, 91, 114, 94]
            }, {
                name: 'Ethereum',
                data: [44, 55, 57, 56, 61, 58, 63, 60, 66]
            }],
        },
        countrydata:
        {
            options:
            {

                grid: {
                    yaxis: {
                        lines: {
                            show: false,
                        },
                    },
                },

                plotOptions: {
                    bar: {
                        horizontal: true,
                        columnWidth: "10",
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                colors: ["#1e3d73"],
                series: [
                    {
                        data: [400, 430, 448, 470, 540, 580],
                    },
                ],
                xaxis: {
                    categories: [
                        "South Korea",
                        "Canada",
                        "United Kingdom",
                        "Netherlands",
                        "Italy",
                        "France",
                    ],
                }
            },
            series: [
                {
                    data: [400, 430, 448, 470, 540, 580],
                },
            ]
        },
        cityreport:
        {
            options:
            {
                chart: {
                    stacked: true,
                    toolbar: {
                        show: false
                    },
                    zoom: {
                        enabled: true
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                    },
                },
                grid: {
                    show: false,
                    padding: {
                        left: -20,
                        bottom: -15
                    }
                },
                xaxis: {
                    labels: {
                        show: false
                    },
                    lines: {
                        show: false
                    },
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    }
                },
                yaxis: {
                    labels: {
                        show: false
                    },
                    lines: {
                        show: false
                    },
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    }
                },
                legend: {
                    show: false
                },
                fill: {
                    opacity: 1
                },
                bar: {
                    columnWidth: 10
                },
                dataLabels: {
                    enabled: false
                },
                colors: ["#1e3d73", '#ffc107'],
            },
            series: [{
                name: 'PRODUCT A',
                data: [13, 23, 20, 8, 13, 27, 13, 23, 20, 8, 13, 27,13, 23, 20, 8, 13, 27, 13, 23, 20, 8, 13, 27]
            }, {
                name: 'PRODUCT B',
                data: [44, 55, 41, 67, 22, 43, 44, 55, 41, 67, 22, 43,44, 55, 41, 67, 22, 43, 44, 55, 41, 67, 22, 43]
            }],
        },
        donut:
        {
            series: [3, 28, 67],
            options: {                
                dataLabels: {
                    enabled: false
                },
                legend: {
                    show: true,
                    position: 'bottom',
                },
                colors: ["#1e3d73", '#17a2b8', '#ffc107'],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },
        }
    }
]
